import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "mini-wizard-featured-reward" }
const _hoisted_2 = { class: "_pos-r" }
const _hoisted_3 = { class: "gfu-labels gfu-labels--bottom _ml-3" }
const _hoisted_4 = { class: "_px-3 _pt-3" }
const _hoisted_5 = {
  class: "gfu-hd gfu-hd--h3 gfu-hd--decorative _line-clamp-2",
  "data-qa": "mini-wizard-featured-reward:Name"
}
const _hoisted_6 = {
  class: "gfu-price gfu-bt--b2",
  "data-qa": "mini-wizard-featured-reward-price:Effective"
}
const _hoisted_7 = {
  class: "gfu-price gfu-price--old _fw-n _ml-1",
  "data-qa": "mini-wizard-featured-reward-price:Old"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_router_link = _resolveComponent("router-link")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_display_currency_price = _resolveComponent("display-currency-price")
  const _component_add_product_to_cart = _resolveComponent("add-product-to-cart")
  const _component_product_card_list_provider = _resolveComponent("product-card-list-provider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: $options.route,
        class: "gfu-embed gfu-embed--1x1 _fo"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_image, {
            class: "gfu-embed__item _rounded-tl--common _rounded-tr--common",
            src: _ctx.featuredReward.imageUrl,
            alt: _ctx.featuredReward.name
          }, null, 8 /* PROPS */, ["src", "alt"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_badge, { "data-qa": "mini-wizard-featured-reward:FeaturedBadge" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardFeaturedRewardBadge), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, [
        _createVNode(_component_router_link, { to: $options.route }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.featuredReward.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"])
      ]),
      _createVNode(_component_display_currency_price, {
        "effective-price": _ctx.featuredReward.effectivePrice,
        "icon-classes": "gfu-icon--small",
        price: _ctx.featuredReward.price,
        "is-discounted": _ctx.featuredReward.isDiscounted,
        class: "_flex _ai-c"
      }, {
        "effective-price": _withCtx(({ effectivePrice }) => [
          _createElementVNode("span", _hoisted_6, _toDisplayString(effectivePrice), 1 /* TEXT */)
        ]),
        price: _withCtx(({ price }) => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(price), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["effective-price", "price", "is-discounted"]),
      _createVNode(_component_product_card_list_provider, {
        products: [_ctx.featuredReward]
      }, {
        default: _withCtx(({ onItemAdded, getAddProductToCartModel }) => [
          _createVNode(_component_add_product_to_cart, _mergeProps($options.getAddToCartModel(getAddProductToCartModel(_ctx.featuredReward)), {
            class: "_mt-3",
            onItemAdded: onItemAdded,
            "data-qa": `mini-wizard-button:SelectThisReward`
          }), null, 16 /* FULL_PROPS */, ["onItemAdded"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["products"])
    ])
  ]))
}